import { gql, useLazyQuery } from "@apollo/client";
import { isValidCharacters } from "../../../Utils/Functions";
import { useEffect, useState } from "react";

import { useFilters } from "../Filters.hook";

const ALL_ESTATES_QUERY = gql`
	query Estates($first: Int!) {
		estates(first: $first) {
			data {
				id
				country_id
				name
				order
			}
		}
	}
`;

const NEIGHBOURHOODS_BY_ESTATE_ID = gql`
	query Neighborhoods($estate_id: Int!) {
		neighborhoods(estate_id: $estate_id) {
			name
			id
			estate {
				id
			}
		}
	}
`;

export interface LocationProps {
	filterChanged: ({ }: any) => void;
	collapsable?: boolean;
	labeled?: boolean;
}

export const useLocation = (props: LocationProps) => {
	// hook setup
	const { filters, filtersTags, changeFilters } = useFilters();
	const [estates, setEstates] = useState<any>([]);

	const [searchEstatesQuery, { data: estatesData, loading: estatesLoading }] = useLazyQuery(ALL_ESTATES_QUERY);
	const [getNeighbourhoodsQuery, { data: neighbourhoods, loading: neighbourhoodsLoading }] = useLazyQuery(NEIGHBOURHOODS_BY_ESTATE_ID);

	useEffect(() => {
		if (estatesData && estatesData.estates) {			
			const filteredData = estatesData.estates.data
				.filter(item => item.order !== -1)
				.sort((a, b) => b.order - a.order)
				.map(({ id, name, neighborhoods }) => {
					const initialLetter = name.charAt(0).toUpperCase()
					return { id, name, neighborhoods,letter:initialLetter }
				});

			setEstates(filteredData);
		} else {
			searchEstatesQuery({ variables: { first: 100 } })
		}
	}, [estatesData]);

	const getNeighbourhoodsByEstateId = (id: string) => {
		if (id) {
		  const estateId = parseInt(id);
		  if (!isNaN(estateId)) {
			getNeighbourhoodsQuery({ variables: { estate_id: estateId } });
		  }
		}
	  };

	return {
		show: true,
		selectedByUrl: filtersTags.estate_id,
		estates,
		estatesLoading,
		getNeighbourhoodsByEstateId,
		neighbourhoods: neighbourhoods,
		neighbourhoodsLoading
	};
};
